module.exports = __webpack_public_path__ + "static/media/pause.d8d3b186.svg";